var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 23,
    rx: 3.5,
    stroke: "#d9d9d9",
    width: 34,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.176 5C25.944 5 29 8.09 29 11.903c0 3.813-3.056 6.903-6.824 6.903a6.748 6.748 0 01-4.426-1.652 6.748 6.748 0 01-4.426 1.652c-3.768 0-6.824-3.09-6.824-6.903C6.5 8.091 9.556 5 13.324 5a6.75 6.75 0 014.426 1.65A6.75 6.75 0 0122.176 5z",
    fill: "#ed0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.176 5C25.944 5 29 8.09 29 11.903c0 3.813-3.056 6.903-6.824 6.903a6.748 6.748 0 01-4.426-1.652 6.918 6.918 0 002.397-5.25A6.92 6.92 0 0017.75 6.65 6.75 6.75 0 0122.176 5z",
    fill: "#f9a000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 6.65a6.919 6.919 0 012.397 5.252 6.918 6.918 0 01-2.397 5.251 6.918 6.918 0 01-2.397-5.25A6.92 6.92 0 0117.75 6.65z",
    fill: "#ff5e00"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/mastercard-082893fad1e628cbb57ce17b8780a9b6.svg";
export { SvgMastercard as Component };